const setLocationData = (feature) => { 
  return {
    type: 'SEARCH_LOCATION',
    payload: feature,
  }
}

export {
  setLocationData,
}